module.exports = __webpack_public_path__ + "img/example-02-original.cd753077.jpg";